import { z } from 'zod';

import { schemaApplicantAttributionBoth } from '../../utils/schema.utils';

// TODO extra validierung hinzufügen
export const Kontoverbindung = z.object({
    // maybe add a stricter validation for bic like regex(/^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/)
    bic: z.string().nullish().default(null),
    gehoertZuAntragsteller: schemaApplicantAttributionBoth.nullish().default(null),
    // maybe add stricter validation for iban like the checkIBAN function in the frontend
    iban: z.string().nullish().default(null),
    kreditinstitut: z.string().nullish().default(null),
});

// INFO yup schema
//             kontoverbindung: yup.object().shape(
//                 {
//                     bic: yup
//                         .string()
//                         .uppercase()
//                         .optional()
//                         .nullable()
//                         .default(null)
//                         .test(...yupTests.bic),
//                     gehoertZuAntragsteller: yup
//                         .string()
//                         .oneOf(['ANTRAGSTELLER_1', 'ANTRAGSTELLER_2', 'BEIDE', null])
//                         .optional()
//                         .nullable()
//                         .default(null),
//                     iban: yup
//                         .string()
//                         .optional()
//                         .nullable()
//                         .test(...yupTests.iban),
//                     kreditinstitut: yup.string().optional().nullable().default(null),
//                 },
//                 bankAccountFieldValidationOrder,
//             )
